import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const RowActionSendOff = () => (_jsx("button", Object.assign({ className: 'btn btn-tertiary small', disabled: true, type: 'button' }, { children: "\u898B\u9001\u308A\u6E08" })));
export default RowActionSendOff;
